import { useState, useEffect } from "react";
import { projectFirestore, timestamp } from "../../firebase-config/config";
import { useAuthContext } from "./useAuthContext";
import { useFirestore } from "./useFirestore";

const useWishlist = () => {
  const [wishlistItems, setWishlistItems] = useState([]);
  const { user } = useAuthContext();
  const { addDocument, deleteDocument } = useFirestore("wishlist");

  // Listen to wishlist changes in real-time
  useEffect(() => {
    if (user) {
      const unsubscribe = projectFirestore
        .collection("wishlist")
        .where("userId", "==", user.phoneNumber)
        .onSnapshot((snapshot) => {
          const items = snapshot.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
          }));
          setWishlistItems(items);
        });

      return () => unsubscribe();
    }
  }, [user]);

  const addToWishlist = async (productId) => {
    // Check if item already exists in wishlist
    const existingItem = wishlistItems.find(
      (item) => item.productId === productId
    );

    if (!existingItem) {
      await addDocument({
        userId: user.phoneNumber,
        productId,
        createdAt: timestamp.fromDate(new Date()),
        updatedAt: timestamp.fromDate(new Date()),
      });
    }
  };

  const removeFromWishlist = async (wishlistItemId) => {
    await deleteDocument(wishlistItemId);
  };

  return { wishlistItems, addToWishlist, removeFromWishlist };
};

export default useWishlist;
